/**
 * @param {string} reference
 * @returns {boolean}
 */
export function validateReference(reference) {
    if (typeof reference !== 'string') {
        return false;
    }
    reference = reference.replaceAll(' ', '');
    if (reference.length.length < 2) {
        return false;
    }

    //To upper case
    reference = reference.toUpperCase();
    var r = reference;
    var isRF = false;

    //Check if this is a rf reference
    if (r.includes('RF')) {
        if (reference.length < 4) {
            return false;
        }
        //Is rf reference, remove first 4 characters
        r = r.substring(4);
        isRF = true;
    }

    //Remove last character
    r = r.substring(0, r.length - 1);

    //Calculate comparison reference
    var compareReference = calculateReference(r, isRF);

    if (compareReference.length > 1) {
        if (isRF) {
            if (compareReference.substring(0, 4).toUpperCase() === reference.substring(0, 4) &&
                compareReference[compareReference.length - 1] === reference[reference.length - 1]) {
                return true;
            }
        } else {
            if (compareReference[compareReference.length - 1] === reference[reference.length - 1]) {
                return true;
            }
        }
    }

    return false;
}

/**
 * @param {string} reference
 * @param {boolean} isRF
 * @returns {string}
 */
export function calculateReference(reference, isRF) {
    //Pad with zeros, until length is 19
    while (reference.length < 19) {
        reference = '0' + reference;
    }

    //Calculate total
    var weight = [7, 3, 1];
    var currentPosition = 0;
    var total = 0;
    reference = reference.trim();
    for (var i = reference.length - 1; i >= 0; i--) {
        total += parseInt('0' + reference[i]) * weight[currentPosition % 3];
        currentPosition++;
    }
    total = (10 - (total % 10)) % 10;

    //Trim front zeros
    while (reference.startsWith('0')) {
        reference = reference.substring(1);
    }

    //Add total
    reference = reference + total;

    if (isRF) {
        //Transform into rf reference
        /**
         * @param {string} x
         * @param {number} y
         * @returns {number}
         */
        var modString = (x, y) => {
            if (x.length === 0) {
                return 0;
            }
            var x2 = x.substring(0, x.length - 1);
            var x3 = parseInt(x.substring(x.length - 1));
            return (modString(x2, y) * 10 + x3) % y
        };

        var rf = reference + '271500';
        var value = modString(rf, 97);
        var checkSum = 98 - value;
        reference = (checkSum < 10 ? 'RF0' : 'RF') + checkSum + reference;
    }

    return reference;
}